<template>
	<div>
		<template v-if="isIE()">
			<form>
				<input type="text" :readonly="isReadOnly" v-on:keyup="validate" v-on:change="updateDate" v-model="dateCustom" :maxlength="getMaxlength" :placeholder="getPlaceholder" autofill="off" autocomplete="false" />
			</form>
			<div v-if="failedValidation">
				{{ $t('datetime.validation-failed.please-enter-format') }}:
				{{ this.time ? 'dd-mm-yyyy hh:ii' : 'dd-mm-yyyy' }}
			</div>
		</template>
		<template v-else>
			<datetime
				v-if="!time"
	            :phrases="{ok: 'Vælg', cancel: 'Annuller'}"
	            :format="{ year: 'numeric', month: 'long', day: 'numeric' }"
	            :placeholder="$t('inputs.date.placeholder')"
	            format="dd-MM-yyyy"
	            type="date"
	            :readonly="isReadOnly"
	            v-model="date"
	            :input-id="id"
	            zone="UTC"
	            value-zone="UTC"

	        ></datetime>
	        <datetime
	        	v-if="time"
                :input-id="id"
                :phrases="{ok: 'Vælg', cancel: 'Annuller'}"
                :format="{ year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }"
                :minute-step="15"
                :placeholder="$t('inputs.date-time.placeholder')"
				format="dd-MM-yyyy kl. HH:mm"
	            zone="UTC"
	            value-zone="UTC"
				type="datetime"
				v-model="date"
				 />
	    </template>
	</div>
</template>

<script>
	import Vue from 'vue';
    import { Datetime } from 'vue-datetime';
    import 'vue-datetime/dist/vue-datetime.css';
    import Datepicker from 'simple-vue-datepicker';


    Vue.filter('formatDate', function(value) {
        if (value) {
            return moment(String(value)).format('DD-MM-YYYY')
        }
    });

	export default {
		props: [
			'value',
			'id',
			'readonly',
			'time'
		],
		data: () => ({
			date: '',
			isReadOnly: false,
			dateCustom: '',
			failedValidation: false,
			format: 'dd-mm-yyyy'
		}),
		computed: {
			getPlaceholder() {
				return this.time ? 'dd-mm-yyyy hh:ii' : 'dd-mm-yyyy';
			},
			getMaxlength() {
				return this.time ? 16 : 10;
			}
		},
		components: {
			datetime: Datetime,
			Datepicker
		},
		watch: {
			value: {
				handler: function(val, oldVal) {
					this.date = val;
            		this.parseCustomDate();
				},
				deep: true
			},
            date: {
                handler: function(val, oldVal) {
                	this.onChange();
                },
                deep: true
            }
        },
		methods: {

			getFormatExample() {
				return this.getPlaceholder();
			},
			parseCustomDate() {
				if (typeof this.date == 'string' && this.date) {
					if (this.time) {
						var parts = this.date.substr(0, 10).split('-');
					} else {
						var parts = this.date.split('-');
					}
					let d = parts[2];
					let m = parts[1];
					let y = parts[0];
					this.dateCustom = d + '-' + m + '-' + y;
					if (this.time) {
						this.dateCustom += this.date.substr(10, 6);
					}
				}
			},
			updateDate() {
				if (this.dateCustom.length == 10 && !this.time) {
					let parts = this.dateCustom.split('-');
					let d = parts[0];
					let m = parts[1];
					let y = parts[2];
					this.date = y + '-' + m + '-' + d;
				} else if (this.dateCustom.length == 16 && this.time) {
					let parts = this.dateCustom.substr(0, 10).split('-');
					let d = parts[0];
					let m = parts[1];
					let y = parts[2];
					this.date = y + '-' + m + '-' + d + this.dateCustom.substr(10, 6);
				} else {
					this.date = '';
				}
			},
			validate() {
				if (this.dateCustom) {
					if (this.time) {
						this.failedValidation = !this.dateCustom.match(new RegExp('^[0-9]{2}\-[0-9]{2}\-[0-9]{4} [0-9]{2}\:[0-9]{2}$'));
					} else {
						this.failedValidation = !this.dateCustom.match(new RegExp('^[0-9]{2}\-[0-9]{2}\-[0-9]{4}$'));
					}
				} else {
					this.failedValidation = false;
				}
			},
			isIE() {
				return navigator.userAgent.indexOf("MSIE") != -1  || (!!document.documentMode == true );
			},
			onChange: function() {
				let event = {
					id: this.id,
					value: this.date
				};
				this.$root.$emit('datetimechange', event);
				this.$emit('change');
			}
		},
		mounted() {
			this.date = this.value;
			this.isReadOnly = this.readonly ? this.readonly : false;
            this.parseCustomDate();
		}
	}
</script>
